module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00025-fs8.0074ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00025-fs8.png
// module id = 178
// module chunks = 0